import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { BrowserCacheLocation } from "@azure/msal-browser";
import { MsalService } from '@azure/msal-angular';
import { MessagesService } from './messages.service';



@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private apiUrl = environment.apiUrl;
  private isAuthenticated = false;

  constructor(private http: HttpClient,
    private messagesService: MessagesService,
    private router: Router,
    private msalService: MsalService) {
    const storedToken = localStorage.getItem('token1');
    if (storedToken) {
      this.isAuthenticated = true;
    }
  }

  login(username: string, password: string): Promise<boolean> {
    if (username === 'Alexis' && password === '12345') {
      this.isAuthenticated = true;
      localStorage.setItem('token1', 'mitoken');
      localStorage.setItem('rol', 'Administrador')
      return Promise.resolve(true);
    }
    if (username === 'Admin Proyecto' && password === '12345') {
      this.isAuthenticated = true;
      localStorage.setItem('token1', 'mitoken');
      localStorage.setItem('rol', 'Administrador del proyecto')
      return Promise.resolve(true);
    }
    if (username === 'Sup Proyecto' && password === '12345') {
      this.isAuthenticated = true;
      localStorage.setItem('token1', 'mitoken');
      localStorage.setItem('rol', 'Supervisor del proyecto')
      return Promise.resolve(true);
    }
    if (username === 'Res Proyecto' && password === '12345') {
      this.isAuthenticated = true;
      localStorage.setItem('token1', 'mitoken');
      localStorage.setItem('rol', 'Responsable del proyecto')
      return Promise.resolve(true);
    }
    if (username === 'Coordinador' && password === '12345') {
      this.isAuthenticated = true;
      localStorage.setItem('token1', 'mitoken');
      localStorage.setItem('rol', 'Coordinador administrativo')
      return Promise.resolve(true);
    }
    if (username === 'Dir GeneralA' && password === '12345') {
      this.isAuthenticated = true;
      localStorage.setItem('token1', 'mitoken');
      localStorage.setItem('rol', 'Director general adjunto')
      return Promise.resolve(true);
    }
    if (username === 'Dir Estrategico' && password === '12345') {
      this.isAuthenticated = true;
      localStorage.setItem('token1', 'mitoken');
      localStorage.setItem('rol', 'Director estrategico')
      return Promise.resolve(true);
    }
    if (username === 'Dir General' && password === '12345') {
      this.isAuthenticated = true;
      localStorage.setItem('token1', 'mitoken');
      localStorage.setItem('rol', 'Director general')
      return Promise.resolve(true);
    }
    else {
      this.isAuthenticated = false;
      return Promise.resolve(false);
    }
  }

  logintoken(data: any): Promise<boolean> {
    const body = {
      username: data.account.username,
    };

    const headers = new HttpHeaders({
      'App_id': environment.azure.clientId
    });

    return new Promise((resolve, reject) => {
      this.http.post(`${this.apiUrl}/login/token`, body, { headers })
        .subscribe(
          (response: any) => {
            this.isAuthenticated = true;
            localStorage.setItem('Id_Usuario', response.authenticated.Id_Usuario);
            localStorage.setItem('token1', response.token);
            localStorage.setItem('rol_id', response.authenticated.rol);

            if (response.authenticated.rol === 14) {
              localStorage.setItem('roles_seleccionados', response.authenticated.roles);
              localStorage.setItem('roles_nombre', response.authenticated.roles_nombres);
            } else {
              localStorage.setItem('rol', response.authenticated.rol_nombre);
            }
            
            localStorage.setItem('username', response.authenticated.NombreCompleto)
            this.messagesService.showMessage('Bienvenido ' + response.authenticated.NombreCompleto);
            resolve(true);
          },
          (error) => {
            console.error('Error en la solicitud de login', error);
            reject(false);
          }
        );
    });
  }

  Authenticated(){
    this.isAuthenticated = false;
    window.location.reload();
  }

  logout(): void {
    const token = localStorage.getItem('token1');
    if (token) {
      this.cerrar(token);
    }
  }
  
  cerrar(token: string): void {
    const headers = new HttpHeaders({
      'Authorization': `${token}` // Asegúrate de que el formato del token sea correcto
    });
    this.http.post(`${this.apiUrl}/logout`, {}, { headers }).
      subscribe(
        (res: any) => {
          if(res.message === 'Cierre de sesion'){
            localStorage.clear()
            this.isAuthenticated = false;
            localStorage.removeItem('token1');
            this.msalService.logout();
            this.msalService.logoutRedirect({ postLogoutRedirectUri: '/' });
          }
        // Limpiar datos de localStorage o realizar otras acciones después de cerrar sesión
      }, (err) => {
        console.warn(err);
        // Manejar errores de logout si es necesario
      }
    );
  }

  public isAuthenticatedUser(): boolean {
    return this.isAuthenticated;
  }
  
  getDatos(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/datos`);
  }

  postDatos(datos: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/datos`, datos);
  }





  async initMsalAD() {
    const msalConfig = {
      auth: {
        clientId: environment.azure.clientId,
        authority: environment.azure.authority,
        redirectUri: environment.azure.redirectUri
      },
      cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage
      },

    };

    await this.msalService.initialize();
    await this.msalService.handleRedirectObservable();
    // await msalInstance.handleRedirectPromise(); // This will no longer throw this error since initialize completed before this was invoked
    // msalConfig.acquireTokenSilent();

  }
}
